package com.vizio.redwolf.consent.api

import com.vizio.redwolf.utils.ResponseHeaders
import kotlin.js.JsExport

@JsExport
sealed class ConsentResult<out T : Any> {
    data class Success<out T : Any>(val headers: ResponseHeaders, val data: T) : ConsentResult<T>()
    data class Failed(val headers: ResponseHeaders, val message: String) : ConsentResult<Nothing>()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : ConsentResult<Nothing>()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : ConsentResult<Nothing>()

    fun <R> fold(
        onSuccess: (Success: Success<T>) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Success -> onSuccess(Success(this.headers, this.data))
            is Failed -> onFailed(Failed(this.headers, this.message))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}